module.exports = __webpack_public_path__ + "static/media/pic4.3acf5e54.jpg";